import { useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Minus, Phone } from "lucide-react";
import { PageHero } from "../components/sections";
import { Reveal, Eyebrow } from "../components/common";
import { FAQ, IMAGES, COMPANY } from "../data/site";
import Seo from "../components/Seo";
import { SEO } from "../data/seo";

export default function Faq() {
  const [open, setOpen] = useState(0);
  return (
    <div data-testid="faq-page">
      <Seo {...SEO.faq} />
      <PageHero
        eyebrow="FAQ"
        title="Toutes vos <em style='color:var(--gold-2)'>questions</em>"
        sub="Conciergerie Airbnb, ménage location saisonnière, gestion du linge, paniers d'accueil et nos applications Cleanéo & HostBook."
        image={IMAGES.cleaningBath}
      />

      <section className="section">
        <div className="container-x grid lg:grid-cols-3 gap-12">
          <div className="lg:col-span-2">
            <div data-testid="faq-list">
              {FAQ.map((item, i) => (
                <div className="acc-item" key={i}>
                  <button
                    className="acc-trigger"
                    onClick={() => setOpen(open === i ? -1 : i)}
                    data-testid={`faq-trigger-${i}`}
                  >
                    {item.q}
                    {open === i ? (
                      <Minus size={22} style={{ color: "var(--gold)", flexShrink: 0 }} />
                    ) : (
                      <Plus size={22} style={{ color: "var(--gold)", flexShrink: 0 }} />
                    )}
                  </button>
                  <div
                    className="acc-body"
                    style={{
                      maxHeight: open === i ? 320 : 0,
                      opacity: open === i ? 1 : 0,
                    }}
                  >
                    <p className="pb-6 pr-8">{item.a}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <aside>
            <Reveal>
              <div className="p-8 sticky top-28" style={{ background: "var(--cream)", border: "1px solid var(--line)" }}>
                <Eyebrow>Une autre question ?</Eyebrow>
                <h3 className="font-display text-3xl mt-3">Parlons-en</h3>
                <p className="mt-3 text-sm" style={{ color: "var(--muted)" }}>
                  Contactez-nous via le site, par téléphone ou WhatsApp. Nous
                  répondons sous 24h.
                </p>
                <Link to="/contact" className="btn btn-primary w-full justify-center mt-6">
                  Demander un devis
                </Link>
                <a href={`tel:${COMPANY.phoneIntl}`} className="btn btn-outline-dark w-full justify-center mt-3">
                  <Phone size={16} /> {COMPANY.phone}
                </a>
              </div>
            </Reveal>
          </aside>
        </div>
      </section>
    </div>
  );
}
